import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ModalVisualizarDocumentos } from "../../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalVisualizarAviso } from "../../../../../components/Generales/ModalVisualizarAviso";
import { ModalVisualizarAplicar } from "../../../../../components/Generales/ModalVisualizarAplicar";
import { ModalCondicionesGenerales } from "../../../../../components/Generales/ModalCondicionesGenerales";
import { ModalModificaciones } from "../../../../../components/Generales/ModalModificaciones";
import { Button, Empty, Table, Popover, Card, Typography, List } from "antd";
import { RootState } from "../../../../../redux/reducers";
import { UseVerConvocatorias } from "../../../../../hooks/UseVerConvocatorias";
import { useNavigate } from "react-router";
import "./Information.scss";
import { useEncrypt } from "../../../../../hooks/useEncrypt";
import { openNotification } from "../../../../../utils/Notifactions";
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
import getStorageUser from "../../../../../middlewares/GetStorageUser"
import moment from "moment";
import apiMaestras from "../../../../../api/Maestras/api-maestras";
import hojavida from "../../../../../assets/hoja_vida.svg";
import presupuesto from "../../../../../assets/presupuesto.svg";
import propuesta from "../../../../../assets/propuesta.svg";
import anexo from "../../../../../assets/anexo.svg";
import { Cards } from "../../../components/Cards/cards";
import { useLanding } from "../../../../../hooks/useLanding";
import { ReactComponent as InfoIcon } from "../../../../../assets/info-detalle.svg";
import { ReactComponent as DownloadIcon } from "../../../../../assets/download-detail.svg";
import { ReactComponent as EyeIcon } from "../../../../../assets/eye-detail.svg";
import { ReactComponent as CalendarIcon } from "../../../../../assets/calendar-detail.svg";
import ImageNotFound from "../../../../../assets/enmascarar-detail.png";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";
import apiParticipantes from "../../../../../api/Participantes/api-participantes";
import axios from "axios";
import { ObjNotificaciones } from "../../../../../config/notificaciones";
import { LeftCircleOutlined } from "@ant-design/icons";
import { FilePdfOutlined } from "@ant-design/icons";

interface IProps {
  convocatorias: any;
  isVisualizar?: boolean;
}

type Documento = {
  url_documento: string;
  descripcion: string;
};

export const Information: React.FC<IProps> = (props: IProps) => {
  const { principalState, getConvocatorias } = useLanding();
  const [calculateDayEnd, setCalculateDayEnd] = useState<any>();
  const [calculateDayStart, setCalculateDayStart] = useState<any>();
  const [dataImg, setDataImg] = useState<any>();
  const [user, setUser] = useState<any>({});
  const navigate = useNavigate();
  const { inscribirPropuesta, descargarArchivo, loading } = UseVerConvocatorias();
  const { encrypt } = useEncrypt();
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  useEffect(() => {
    getConvocatorias();
    getLineasConvocatorias();
    const token = localStorage.getItem("token");
    if (token) {
      getUser();
    }
  }, []);

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data && data.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        }
      }
    }
  }

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)

  const getUser = async () => {
    try {
      const user = getStorageUser()
      return setUser(user);
    } catch (error) {
      console.log(error);
    }
  };

  const { Text } = Typography;

  const calculateDate = (fechas: any) => {
    if (fechas !== null && fechas.length > 0) {
      const filterDateStart = fechas.filter((data) => data.clave === "Apertura");
      const filterDateEnd = fechas.filter((data) => data.clave === "Cierre");

      if (filterDateStart.length > 0) {
        setCalculateDayStart(moment(filterDateStart[0].valormin));
      }

      if (filterDateEnd.length > 0) {
        if (filterDateEnd[0].valormax && moment(filterDateEnd[0].valormax).isValid()) {
          setCalculateDayEnd(moment(filterDateEnd[0].valormax));
        } else {
          setCalculateDayEnd(moment(filterDateEnd[0].valormin));
        }
      }
    }
  }

  const [timeRemaining, setTimeRemaining] = useState({
    mounths: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isFinished: false
  });

  useEffect(() => {
    getImageConvocatoria();
    calculateDate(props.convocatorias.fechas);
  }, [props.convocatorias]);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment()
      const diff = moment(calculateDayEnd).subtract(1, 'hours').diff(now);
      if (diff <= 0) {
        clearInterval(interval);
        setTimeRemaining({
          mounths: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isFinished: true
        });
      } else {
        const duration = moment.duration(diff);
        setTimeRemaining({
          mounths: duration.months(),
          days: duration.days(),
          hours: duration.hours(),
          minutes: duration.minutes(),
          seconds: duration.seconds(),
          isFinished: false
        });
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [calculateDayEnd]);

  const { mounths, days, hours, minutes, seconds, isFinished } = timeRemaining;

  async function obtenerHoraActualColombia() {
    const response = await fetch('http://worldtimeapi.org/api/timezone/America/Bogota');
    const data = await response.json();
    const fechaYHora = new Date(data.datetime);
    return fechaYHora;
  }

  const [loadingAplicar, setLoadingAplicar] = useState<boolean>(false);

  const insrcribirme = async () => {
    setLoadingAplicar(true)
    try {
      const token = localStorage.getItem('token')
      const validateToken = await axios.get(`${process.env.REACT_APP_SERVER_USERS}users/token/${token}`);

      if (validateToken?.data?.status !== 200 && token != '') {
        navigate('/login');
        ObjNotificaciones.MSG_ERROR('warning', 'Sesión expirada', 'Tú sesión ha expirado, intenta iniciar sesión nuevamente');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }

      //const fechaActual = await obtenerHoraActualColombia();
      let fechaActual = new Date();
      let anio = fechaActual.getFullYear();
      let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
      let dia = ('0' + fechaActual.getDate()).slice(-2);
      let hora = ('0' + fechaActual.getHours()).slice(-2);
      let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
      let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

      const cierre = props.convocatorias.fechas.filter((data) => data.clave === "Cierre")[0].valormax;
      let cierreAct = new Date(cierre);
      cierreAct.setHours(cierreAct.getHours() - 1);

      let anioc = cierreAct.getFullYear();
      let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
      let diac = ('0' + cierreAct.getDate()).slice(-2);
      let horac = ('0' + cierreAct.getHours()).slice(-2);
      let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);


      let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

      if (fechaYHoraActualizada <= fechaYHora){
        openNotification({
          titulo: "Error",
          descripcion:
            "No puedes inscribirte a una convocatoria que no esté abierta",
          placement: "bottomRight",
        });
        return navigate('/usuario');
      }

      if (!props.convocatorias.fechas || props.convocatorias.fechas.length < 1) {
        openNotification({
          titulo: "Error",
          descripcion:
            "No puedes inscribirte a una convocatoria que no esté abierta",
          placement: "bottomRight",
        });
        return navigate('/usuario');
      }

      if (
        props.convocatorias.fechas !== null &&
        props.convocatorias.fechas.length > 0
      ) {
        const { data } = await apiConvocatorias.obtenerConvocatoriaConEstado(
          props.convocatorias.idconvocatorias
        );
        if (data === "En espera" || data === "En proceso" || data === "Cerrada"  || data ===  "No publicada") {
          openNotification({
            titulo: "Error",
            descripcion:
              "No puedes inscribirte a una convocatoria que no esté abierta",
            placement: "bottomRight",
          });
          return navigate('/usuario');
        }
      }

      localStorage.removeItem("id_postulacion");
      localStorage.setItem(
        "idConvocatoriaPostulacion",
        encrypt(props.convocatorias.idconvocatorias.toString())
      );

      if (user === null) {
        if (props.convocatorias.tipo === 1) {
          return navigate(`/login/1/${props.convocatorias.idconvocatorias}`);
        }
        if (props.convocatorias.tipo === 2) {
          return navigate(`/login/3/${props.convocatorias.idconvocatorias}`);
        }
        if (props.convocatorias.tipo === 3) {
          return navigate(`/login/2/${props.convocatorias.idconvocatorias}`);
        }
      }

      const validatePostulacion = await apiParticipantes.validarPostulacion(Number(props.convocatorias.idconvocatorias), user?.documento?.toString());

      if (validatePostulacion?.data !== null) {
        openNotification({
          titulo: "¡Ya tienes una postulación activa a esta convocatoria",
          descripcion:
            "Por favor, gestiona tu postulación desde mis proyectos",
          placement: "bottomRight",
        });

        if (props.convocatorias.tipo === 1) {
          return navigate("/usuario/Mispostulaciones");
        }

        if (props.convocatorias.tipo === 2) {
          return navigate("/usuario/MenuJurado");
        }

        if (props.convocatorias.tipo === 3) {
          return navigate("/usuario/subsanarBeps");
        }
      }

      if (props.convocatorias.tipo === 1) {
        inscribirPropuesta(props.convocatorias, idParticipante);
        return navigate("/usuario/Seleccionarrol");
      }

      if (props.convocatorias.tipo === 2) {
        inscribirPropuesta(props.convocatorias, idParticipante);
        return navigate("/usuario/Inscribirhojadevida");
      }

      if (props.convocatorias.tipo === 3) {
        inscribirPropuesta(props.convocatorias, idParticipante);
        return navigate("/usuario/beps");
      }
    } catch (error) {
      mostrarModalAplicar()
      navigate('/login');
        ObjNotificaciones.MSG_ERROR('warning', 'Sesión expirada', 'Tú sesión ha expirado, intenta iniciar sesión nuevamente');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
    }
  };

  const { idParticipante } = useSelector(
    (state: RootState) => state.participantes
  );

  const [visualizasdocument, setVisualizarDocument] = useState<boolean>(false);
  const [urldocumento, setUrldocumento] = useState<string>("");

  const visualizarModal = () => {
    setVisualizarDocument(true);
  };

  const [visualizarAviso, setVisualizarAviso] = useState<boolean>(true);
  const [visualizarAplicar, setVisualizarAplicar] = useState<boolean>(false);
  const [visualizarCondiciones, setVisualizarCondiciones] = useState<boolean>(true);
  const [visualizarModificaciones, setVisualizarModificaciones] = useState<boolean>(true);

  const mostrarModalAviso = () => {
    setVisualizarAviso(true);
  }

  const mostrarModalAplicar = () => {
    setVisualizarAplicar(true);
  }

  const mostrarModalCondiciones = () => {
    setVisualizarCondiciones(true);
  }

  const columnsAnexos: any = [
    {
      title: "Descripción",
      render: (datos: any) => {
        return datos.descripcion
      },
    },
    {
      title: "Acciones",
      children: [
        {
          title: <span style={{ fontSize: '9px' }}>Ver</span>,
          fixed: 'right',
          align: 'center' as 'center',
          render: (datos: any) => {
            return (
              <Button
                className="button-azul-ghost"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setUrldocumento(datos.url_documento);
                  visualizarModal();
                }}
              >
                <EyeIcon />
              </Button>
            );
          },
        },
        {
          title: <span style={{ fontSize: '9px' }}>Descargar</span>,
          fixed: 'right',
          align: 'center' as 'center',
          render: (datos: any) => {
            return (
              <Button
                className="button-azul-ghost"
                style={{ cursor: 'pointer' }}
                onClick={() => descargarArchivo(datos.url_documento, datos.nombre)}
                loading={loading[datos.nombre] || false} // Asegura que si no existe en el estado, sea false
              >
                <DownloadIcon />
              </Button>
            );
          },
        }
      ]
    }
  ];
  const columnsInformesResolucion: any = [
    {
      title: "Descripción",
      render: (datos: any) => {
        return datos.descripcion
      },
    },
    {
      title: "Acciones",
      children: [
        {
          title: <span style={{ fontSize: '9px' }}>Ver</span>,
          fixed: 'right',
          align: 'center' as 'center',
          render: (datos: any) => {
            return (
              <Button
                className="button-azul-ghost"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setUrldocumento(datos.url_documento);
                  visualizarModal();
                }}
              >
                <EyeIcon />
              </Button>
            );
          },
        },
        {
          title: <span style={{ fontSize: '9px' }}>Descargar</span>,
          fixed: 'right',
          align: 'center' as 'center',
          render: (datos: any) => {
            return (
              <Button
                className="button-azul-ghost"
                style={{ cursor: 'pointer' }}
                onClick={() => descargarArchivo(datos.url_documento, datos.nombre)}
                loading={loading[datos.nombre] || false} // Asegura que si no existe en el estado, sea false
              >
                <DownloadIcon />
              </Button>
            );
          },
        }
      ]
    },
  ];

  return (
    <div className="information-convocatoria-template">
      <Card className="card-detail-convocatoria">
        <div className="container-fluid2 container-date-responsive-card" style={{ textAlign: 'center' }}>
          <div
            style={{ lineHeight: "normal", paddingBottom: "10px" }}
            className="col-12 font-family-Montserrat-Bold font-size-16px font-color-000000"
          >
            Fechas de la convocatoria
          </div>

          <div className="row align-items-center justify-content-center" style={{ maxWidth: '480px', margin: '0 auto' }}>
            <div className="col-3 col-md-2 font-family-Montserrat-Regular font-size-10px font-color-000000">
              <p>
                <CalendarIcon style={{ fontSize: '40px' }} />
              </p>
            </div>

            <div
              className="col-4 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-000000"
            >
              <span className="no-margin container-detalle-card-body-bold" style={{ fontSize: '14px' }}>
                <p className="title_date_detail" style={{ textAlign: 'left' }}><strong>Inicia:</strong></p>
              </span>{" "}
              <div className="container-detalle-card-body-regular title_date_detail" style={{ fontSize: '14px' }}>
                {
                  moment(calculateDayStart).format('DD MMM / YYYY')
                }
              </div>
            </div>

            <div className="col-4 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-000000">
              <span className="no-margin container-detalle-card-body-bold" style={{ fontSize: '14px' }}>
                <p className="title_date_detail" style={{ textAlign: 'left' }}><strong>Finaliza:</strong></p>
              </span>{" "}
              <div className="container-detalle-card-body-regular title_date_detail" style={{ fontSize: '14px' }}>
                {
                  moment(calculateDayEnd).format('DD MMM / YYYY')
                }
              </div>
            </div>
          </div>
        </div>

        <div className="background-detalle-tiempo-faltante">
          <div className="cabecera-detalle-tiempo-faltante cabecera-detalle-tiempo-faltante-no-responsive d-flex flex-column align-items-center justify-content-center">
            <span style={{ marginTop: '5px' }}>{
              isFinished ? <span className="cabecera-detalle-nombre-categoria" style={{ fontSize: '20px' }}>Convocatoria</span> : <span className="container-detalle-semibold" style={{ fontSize: '26px' }}>FALTAN</span>
            }</span>
            <div>
              {isFinished ? (
                <strong style={{ color: '#A50000', fontSize: '22px', marginBottom: '20px' }} className="container-detalle-card-body-semibold-work">
                  CERRADA
                </strong>
              ) : (
                <div>
                  <strong>
                  {mounths.toString().padStart(2, '0') != '00' && (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '6px' }}>
                        <Text style={{ color: '#A50000', fontSize: '22px', marginBottom: '4px' }}>
                          {mounths.toString().padStart(2, '0')} mes
                        </Text>
                      </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '6px' }}>
                      <Text style={{ color: '#A50000', fontSize: '30px', marginBottom: '4px' }}>
                        {days.toString().padStart(2, '0')} días
                      </Text>
                    </div>
                  </strong>
                  <strong style={{ color: '#A50000', fontSize: '22px', marginBottom: '20px' }} className="container-detalle-card-body-semibold-work">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '6px' }}>
                        <Text style={{ color: '#A50000', fontSize: '22px', marginBottom: '4px' }}>
                          {hours.toString().padStart(2, '0')}:
                        </Text>
                        <Text>hh</Text>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '6px' }}>
                        <Text style={{ color: '#A50000', fontSize: '22px', marginBottom: '4px' }}>
                          {minutes.toString().padStart(2, '0')}:
                        </Text>
                        <Text>mm</Text>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Text style={{ color: '#A50000', fontSize: '22px', marginBottom: '4px' }}>
                          {seconds.toString().padStart(2, '0')}
                        </Text>
                        <Text>ss</Text>
                      </div>
                    </div>
                  </strong>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="container-fluid2 cabecera-detalle-convocatoria" style={{ marginTop: '70px' }}>
          <div className="cabecera-detalle-nombre-convocatoria" style={{ fontSize: '28px' }}>
            {props.convocatorias?.nombre_convocatoria}
          </div>
          <div className="cabecera-detalle-nombre-categoria" style={{ fontSize: '28px' }}>
            {getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria)}` : ""}
          </div>
        </div>

        <div className="container-fluid2 container-detalle-card-body-regular" style={{ marginTop: '50px', fontSize: '18px' }}>
          {props.convocatorias.descripcion_corta}
        </div>

        <div className="container-fluid2">
          <Card className="card-detalle-convocatoria">
            <div className="row align-items-center">
              <div className="col-12 col-md-12 col-lg" style={{ fontSize: '18px', width: '100%', margin: '0 auto' }}>
                <div className="row align-items-center row-card-column">
                  <div className="col-12 col-md-3" style={{ display: 'inline-block' }}><InfoIcon className="info-detalle-icon" /></div>
                  <div className="col-12 col-md-8">
                    <p style={{ marginRight: '20px', fontSize: '18px', display: 'inline-block' }} className="container-detalle-card-body-regular container-detalle-info-detail-card col-12 col-md-12 col-lg">Para la convocatoria es importante tener presente la siguiente información y objeto: </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg card-item-perfil-entidad">
                <p><strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>Perfil:</strong> <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>{props.convocatorias?.tipo_participante?.map((tipo) => `${tipo.text}  `)}</span></p>
                <p><strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>Entidad:</strong> <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>{props.convocatorias?.entidad}</span></p>
              </div>
              <div className="col-12 col-md-12 col-lg">
              {props.convocatorias?.entidad !== 'SM' && (
                <div>
                  {props.convocatorias?.linea_estrategica == null ? (
                    <div>
                      <strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>
                        Expresión cultural:
                      </strong>
                      <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                        Varias expresiones
                      </span>
                    </div>
                  ) : (
                    <div>
                      <strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>
                        Expresiones culturales:
                      </strong>
                      <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                        {props.convocatorias?.area?.map((area) => `${area.text} `)}
                      </span>
                    </div>
                  )}
                </div>
              )}

                <p><strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>Línea Estratégica: </strong>
                  {
                    props.convocatorias.tipo !== 2 ?
                      <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>{props.convocatorias?.linea_estrategica}</span>
                      :
                      <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>Banco de jurados</span>
                  }
                </p>
              </div>
            </div>
            <br />
            <div className="row align-items-center">
              { props.convocatorias?.entidad == 'SM' && (
                <p>
                  <strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>Correo electrónico para la atención ciudadana:</strong>
                  <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                    {" "}reconocimientomujeres@medellin.gov.co
                  </span>
                </p>
              )}
              { props.convocatorias?.entidad == 'SCC' && (
                <p>
                  <strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>Correo electrónico para la atención ciudadana:</strong>
                  <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                    {" "}convocatorias.cultura@medellin.gov.co
                  </span>
                </p>
              )}
              { props.convocatorias?.entidad == 'PP' && (
                <p>
                  <strong className="container-detalle-card-body-bold" style={{ fontSize: '18px' }}>Correo electrónico para la atención ciudadana:</strong>
                  <span className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                    {" "}convocatoriaspdlyppcultura@medellin.gov.co
                  </span>
                </p>
              )}
            </div>
          </Card>
        </div>

        <div className="container-fluid2" style={{ marginTop: '60px' }}>
          <div className="container-titles-information-component">
            <div className="container-title-left-morado-information-component font-family-Montserrat-Regular font-size-25px" style={{ color: '#03212D', borderBottom: '1px solid #03212D' }}>
              {props.convocatorias?.entidad == 'SM' && (
                <span className="cabecera-detalle-nombre-convocatoria _x _xblackblue">¿Por qué lo hacemos?</span>
              )}
              {props.convocatorias?.entidad == 'SCC' && (
                <span className="cabecera-detalle-nombre-convocatoria _x _xblackblue">Objeto </span>
              )}
              {props.convocatorias?.entidad == 'PP' && (
                <span className="cabecera-detalle-nombre-convocatoria _x _xblackblue">Objeto </span>
              )}
              {props.convocatorias?.entidad == 'MCM' && (
                <span className="cabecera-detalle-nombre-convocatoria _x _xblackblue">Objeto </span>
              )}
            </div>
          </div>
          {
            <div className="col-12 font-size-18px container-detalle-card-body-regular" style={{ marginTop: '30px', fontSize: '18px' }}>{
              props.convocatorias.objetivo !== null
                ? props.convocatorias.objetivo
                : "La convocatoria no cuenta con un objeto"}
            </div>
          }
        </div>

        <div className="container-fluid2 container-detalle-card-body-regular container-detail-convocatoria-objeto" style={{ marginTop: '30px', fontSize: '14px' }}>
          <div className="detail-convocatoria-objeto-img">
            <img src={dataImg ? dataImg : ImageNotFound} alt="Imagen detalle convocatoria" style={{ width: '700px', height: '480px' }} className="detail-convocatoria-img" />
          </div>
          <div className="detail-convocatoria-objeto-details">
            <div className="container-titles-information-component">
              <div className="container-title-left-morado-information-component font-family-Montserrat-Regular" style={{ color: '#E334A0', borderBottom: '1px solid #E334A0', fontSize: '25px' }}>
                <span className="_x _xrosa"><span className="font-family-Montserrat-Bold">Perfil específico </span> del participante</span>
              </div>
              <div style={{ marginTop: '30px', fontSize: '14px' }} className="font-size-18px">
                {
                  props.convocatorias?.perfil_participante !== null
                    ? <span className="container-detalle-card-body-regular detail-font-18"> {props.convocatorias?.perfil_participante} </span>
                    : <span className="container-detalle-card-body-regular detail-font-18">La convocatoria no cuenta con un perfil específico</span>
                }
              </div>
            </div>

            <div className="container-titles-information-component" style={{ marginTop: '30px' }}>
              <div className="container-title-left-morado-information-component font-family-Montserrat-Regular font-size-24px" style={{ color: '#00A9ED', borderBottom: '1px solid #00A9ED', fontSize: '25px' }}>
                <span className="_x _xblue"><span className="font-family-Montserrat-Bold">Quiénes no pueden </span> participar</span>
              </div>
              <div style={{ marginTop: '30px', fontSize: '14px' }} className="container-detalle-card-body-regular font-size-18px">
                {
                  props.convocatorias?.noparticipa !== null
                    ? <span className="container-detalle-card-body-regular detail-font-18"> {props.convocatorias?.noparticipa} </span>
                    : <span className="container-detalle-card-body-regular detail-font-18">La convocatoria no cuenta con está información</span>
                }
              </div>
            </div>
          </div>
        </div >

        <div className="container-fluid2" style={{ marginTop: '60px' }}>
          <div className="container-titles-information-component">
            <div className="container-title-left-morado-information-component font-family-Montserrat-Regular font-size-24px" style={{ color: '#03212D', borderBottom: '1px solid #03212D', fontSize: '25px' }}>
              <span className="_x _xblacklight"><span className="font-family-Montserrat-Bold">Cronograma </span> de actividades</span>
            </div>
          </div>
        </div>
        <div className="container-fluid2 container-detalle-card-body-regular" style={{ marginTop: '30px' }}>
          <div className="row mt-4">
            {props.convocatorias.fechas !== null &&
              props.convocatorias.fechas.length > 0
              ? props.convocatorias.fechas.sort((a: any, b: any) => + (new Date(a.valormin)) - + (new Date(b.valormin))).map((data, i) => (
                <div key={`contenedor_${i}`} className="row mb-3">
                  <div className="col-12 font-size-14px">
                    <span className="no-margin" style={{ fontSize: '14px' }}>
                      <strong className="container-detalle-card-body-bold">{data.clave}:</strong>
                    </span>{" "}
                    <span style={{ fontSize: '14px' }} className="container-detalle-card-body-regular">
                      {moment(data.valormin).format("LL")}
                      {moment(data.valormax).isValid() && moment(data.valormax).format("L") !== moment(data.valormin).format("L") ? ` al ${moment(data.valormax).format("LL")} ` : ""}
                      {
                        data.clave !== "Apertura" &&
                          data.clave === "Cierre" ||
                            data.clave === "Plazo para subsanar documentos y presentar observaciones" ?
                              moment(data.valormax).isValid() ? ` hasta las ${moment(data.valormax).subtract(1, 'hours').format("hh:mm a")}` : ''
                              :
                              ''
                      }
                    </span>
                  </div>
                </div>
              ))
              : "La convocatoria no cuenta con un cronograma de actividades"}
          </div>
        </div>

        {/* {
          props.convocatorias.tipo !== 2 &&
          <>
            <div className="container-fluid2" style={{ marginTop: '60px' }}>
              <div className="container-titles-information-component">
                <div className="container-title-left-morado-information-component font-family-Montserrat-Regular font-size-24px" style={{ color: '#464646', borderBottom: '1px solid #464646', fontSize: '25px' }}>
                  <span className="_x _xgray"><span className="font-family-Montserrat-Bold">Documentos técnicos </span> para evaluación</span>
                </div>
              </div>
            </div>
            <div className="container-fluid2 container-detalle-card-body-regular" style={{ marginTop: '60px' }}>
              <div className="d-flex justify-content-around text-center container-detail-tecnicos-evaluacion-convocatoria">
                <div className="box-documento-tecnico">
                  <p>
                    <img src={anexo} alt="Anexo" className="img-documentacion-tecnica-evaluacion" />
                  </p>
                  <p className="container-detalle-card-body-semibold detail-font-22">
                    Anexo
                  </p>
                  <p className="descripcion-documentacion-tecnica-evaluacion detail-font-18">
                    En esta convocatoria se te solicitarán algunos documentos necesarios para completar la información general de los participantes, asegúrate de completarlos.
                  </p>
                </div>
                <div className="box-documento-tecnico">
                  <p>
                    <img src={hojavida} alt="Hoja de vida" className="img-documentacion-tecnica-evaluacion" />
                  </p>
                  <p className="container-detalle-card-body-semibold detail-font-22">Hoja de vida</p>
                  <p className="descripcion-documentacion-tecnica-evaluacion detail-font-18">
                    La hoja de vida es un documento que contiene toda la información relacionada con el participante. Usa los descargables de la siguiente tabla para completar esta información.
                  </p>
                </div>
                <div className="box-documento-tecnico">
                  <p>
                    <img src={presupuesto} alt="Presupuesto" className="img-documentacion-tecnica-evaluacion" />
                  </p>
                  <p className="container-detalle-card-body-semibold detail-font-22">Presupuesto</p>
                  <p className="descripcion-documentacion-tecnica-evaluacion detail-font-18">
                    Para esta convocatoria es necesario presentar un presupuesto del proyecto en el formato descargable de la página web completamente diligenciado.
                  </p>
                </div>
                <div className="box-documento-tecnico">
                  <p>
                    <img src={propuesta} alt="Propuesta" className="img-documentacion-tecnica-evaluacion" />
                  </p>
                  <p className="container-detalle-card-body-semibold detail-font-22">Propuesta</p>
                  <p className="descripcion-documentacion-tecnica-evaluacion detail-font-18">
                    Para presentar una propuesta es necesario que la presente en el formato descargable de la página web completamente diligenciado y que contenga los elementos solicitados en el lineamiento.
                  </p>
                </div>
              </div>
            </div>
          </>
        } */}

        <div className="container-fluid2" style={{ marginTop: '60px' }}>
          <div className=" container-titles-information-component">
            <div className="container-title-left-morado-information-component font-family-Montserrat-Regular font-size-24px" style={{ color: '#6D4BE0', borderBottom: '1px solid #6D4BE0', fontSize: '25px' }}>
              <span className="_x _xpurple"><span className="font-family-Montserrat-Bold">Documentación e información </span> a tener en cuenta {" "}</span>
            </div>
          </div>
        </div>
        <div>
          <div className="container-fluid2 mt-4" style={{ marginTop: '30px' }}>
            <div className="row">
              <div className="col-12">
                <br />
                <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                  Lineamientos:
                </div>
                <div className="row">
                  <Table
                    locale={{
                      emptyText: (
                        <Empty
                          description="No hay lineamientos para esta convocatoria"
                          style={{ padding: "1%" }}
                        />
                      ),
                    }}
                    pagination={{ hideOnSinglePage: true }}
                    columns={columnsAnexos}
                    dataSource={
                      props.convocatorias.documentos_generales !== null
                        ? props.convocatorias.documentos_generales.filter(
                          (data) => data.tipo_documento === "Lineamiento"
                        )
                        : []
                    }
                    className="tabla-information-anexos"
                  />
                </div>
                {props.convocatorias?.entidad == 'SCC' && (
                  <div className="row">
                    <Button
                      type="link"
                      className="button-azul-radius-detalle"
                      style={{ fontSize: '14px', width: 'auto', display: 'inline-block', whiteSpace: 'nowrap' }}
                      onClick={mostrarModalCondiciones}
                    >
                      <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Ver condiciones generales</span>
                    </Button>
                  </div>
                )}
                {props.convocatorias?.entidad == 'PDL y PPC' && (
                  <div className="row">
                    <Button
                      type="link"
                      className="button-azul-radius-detalle"
                      style={{ fontSize: '14px', width: 'auto', display: 'inline-block', whiteSpace: 'nowrap' }}
                      onClick={mostrarModalCondiciones}
                    >
                      <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Ver condiciones generales</span>
                    </Button>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-sm-6">
                  <br />
                  <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                    Documentación administrativa:
                  </div>
                  <br />
                  <List
                    bordered
                    dataSource={props.convocatorias.documentos_administrativos as { url_documento: string; descripcion: string; tipo_persona: number }[]}
                    renderItem={(item, index) => (
                      <List.Item
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: item.tipo_persona === 0
                          ? '#ffe4e1' // Rosa pastel para Persona natural
                          : item.tipo_persona === 1
                          ? '#e0f7fa' // Azul pastel para Persona jurídica
                          : '#e8eaf6' // Lila pastel para Grupo conformado
                      }}
                      >
                        <List.Item.Meta
                          // avatar={<FilePdfOutlined style={{ fontSize: '24px', color: '#ff4d4f' }} />}
                          title={
                            <span>
                              <span style={{ fontWeight: 'bold' }}>
                                {`${item.tipo_persona === 0 ? '(Persona natural)' : item.tipo_persona === 1 ? '(Persona jurídica)' : '(Grupo conformado)'}`}
                              </span>
                              {` ${item.descripcion}`}
                              <span>
                                {item.url_documento && item.url_documento != '' && (
                                  <Button
                                    className="button-azul-ghost"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => descargarArchivo(item.url_documento, item.descripcion)}
                                    loading={loading[item.descripcion] || false}
                                  >
                                    <DownloadIcon />
                                  </Button>
                                )}
                              </span>
                            </span>
                          }
                        />
                      </List.Item>
                    )}
                  />
                </div>
                {
                    props.convocatorias.documentos_tecnicos != '' && (
                      <div className="col-12 col-md-6 col-sm-6">
                        <br />
                        <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                          Documentación técnica
                        </div>
                        <br />
                        <List
                          bordered
                          dataSource={props.convocatorias.documentos_tecnicos as { url_documento: string; descripcion: string }[]}
                          renderItem={(item, index) => (
                            <List.Item>
                              <List.Item.Meta
                                // avatar={<FilePdfOutlined style={{ fontSize: '24px', color: '#ff4d4f' }} />}
                                title={
                                  <span>
                                    {index + 1}. {item.descripcion}
                                    <span>
                                    {
                                      item.url_documento && item.url_documento != "" && (
                                        <Button
                                          className="button-azul-ghost"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => descargarArchivo(item.url_documento, item.descripcion)}
                                          loading={loading[item.descripcion] || false}
                                        >
                                          <DownloadIcon />
                                        </Button>
                                      )
                                    }
                                    </span>
                                  </span>
                                }
                              />
                            </List.Item>
                          )}
                        />
                      </div>
                    )
                  }
              </div>
              {/*
              <div className="col-12">
                <br />
                <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                  Formatos:
                </div>
                <div className="row">
                  <Table
                    locale={{
                      emptyText: (
                        <Empty
                          description="No hay formatos para esta convocatoria"
                          style={{ padding: "1%" }}
                        />
                      ),
                    }}
                    pagination={{ hideOnSinglePage: true }}
                    columns={columnsAnexos}
                    dataSource={
                      props.convocatorias.documentos_generales !== null
                        ? props.convocatorias.documentos_generales.filter(
                          (data) => data.tipo_documento === "Formato"
                        )
                        : []
                    }
                    className="tabla-information-anexos"
                  />
                </div>
              </div>
              */}
              <div>
                <div className="col-12">
                  <br />
                  <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                    Resoluciones:
                  </div>
                  <div className="row">
                    <Table
                      locale={{
                        emptyText: (
                          <Empty
                            description="No hay resoluciones para esta convocatoria"
                            style={{ padding: "1%" }}
                          />
                        ),
                      }}
                      columns={columnsInformesResolucion}
                      pagination={{ hideOnSinglePage: true }}
                      dataSource={
                        props.convocatorias.documentos_generales !== null
                          ? props.convocatorias.documentos_generales.filter(
                            (data) => data.tipo_documento === "Resolución"
                          )
                          : []
                      }
                      className="tabla-information-anexos"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <br />
                  <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                    Manual de usuario:
                  </div>
                  <div className="row">
                    <Table
                      locale={{
                        emptyText: (
                          <Empty
                            description="No hay manuales para esta convocatoria"
                            style={{ padding: "1%" }}
                          />
                        ),
                      }}
                      columns={columnsInformesResolucion}
                      pagination={{ hideOnSinglePage: true }}
                      dataSource={
                        props.convocatorias.documentos_generales !== null
                          ? props.convocatorias.documentos_generales.filter(
                            (data) => data.tipo_documento === "Manual"
                          )
                          : []
                      }
                      className="tabla-information-anexos"
                    />
                  </div>
                </div>
              </div>
              {props.convocatorias?.entidad == 'SM' && (
                  <section className="row justify-content-center text-center">
                    <div className="font-size-14px font-family-Montserrat-Bold font-color-FF8900">
                      Video tutorial:
                    </div>
                    <div className="video-wrapper">
                      <div className="video-frame-s">
                        <iframe
                          src="https://drive.google.com/file/d/1DejevFAoLp5R1IPqaVComZrF7FnFSZZJ/preview"
                          allow="autoplay"
                          allowFullScreen
                          loading="lazy"
                          title="Video"
                        ></iframe>
                      </div>
                    </div>
                  </section>
                )}
            </div>
          </div>
        </div>
        <div>
          <div className="container-fluid2 mt-5">
            <div className="container-titles-information-component">
              <div className="container-title-left-azul-information-component font-family-Montserrat-Regular font-size-24px" style={{ color: '#000000', borderBottom: '1px solid #000000', fontSize: '25px' }}>
                <span className="_x _xblack"><span className="font-family-Montserrat-Bold">Informes </span> y avisos</span>
              </div>
            </div>
          </div>
          <div>
            <div className="container-fluid2">
              <div className="row mt-4 mb-3">
                <Table
                  locale={{
                    emptyText: (
                      <Empty
                        description="No hay Informes para esta convocatoria"
                        style={{ padding: "1%" }}
                      />
                    ),
                  }}
                  pagination={{ hideOnSinglePage: true }}
                  columns={columnsInformesResolucion}
                  dataSource={
                    props.convocatorias.documentos_generales !== null
                      ? props.convocatorias.documentos_generales.filter(
                        (data) => data.tipo_documento === "Informes"
                      )
                      : []
                  }
                  className="tabla-information-anexos"
                />
              </div>
            </div>
          </div>
      </div>
        {/*<div className="container-fluid2 mt-5">
          <div className="container-titles-information-component">
            <div className="container-title-left-azul-information-component font-family-Montserrat-Regular font-size-24px" style={{ color: '#FF8900', borderBottom: '1px solid #FF8900', fontSize: '25px' }}>
              <span className="_x _xorange"><span className="font-family-Montserrat-Bold">Otras convocatorias </span> de interés</span>
            </div>
          </div>
        </div>
        <div className="container-fluid2">
          <div className="row mt-4 mb-4 g-3">
            {principalState.convocatoriasslice.sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias).map((data: any, index: number) => (
              <div key={`contenedor_${index}`} className="col-lg-4 col-md-12 col-12">
                <Cards key={index} convocatorias={data} />
              </div>
            ))}
          </div>
        </div>*/}
      </Card >
      {
        !props.isVisualizar && (
          <div className="position-sticky bottom-0 background-buttons-footer" style={{ zIndex: 2 }}>
            <div className="d-flex justify-content-between flex-direction-responsive-buttons">
              {props.convocatorias?.entidad == 'SM' && (
                <Button type="link" style={{ fontSize: '14px' }} className="button-blanco-radius-detalle container-detalle-card-body-bold" onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/mujeres"; }}>
                  <span className="container-detalle-card-body-bold font-responsive-regresar" style={{ fontSize: '14px' }}>REGRESAR</span>
                </Button>
              )}
              {props.convocatorias?.entidad == 'SCC' && (
                <Button type="link" style={{ fontSize: '14px' }} className="button-blanco-radius-detalle container-detalle-card-body-bold" onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/#convocatorias"; }}>
                  <span className="container-detalle-card-body-bold font-responsive-regresar" style={{ fontSize: '14px' }}>REGRESAR</span>
                </Button>
              )}
              {props.convocatorias?.entidad == 'PP' && (
                <Button type="link" style={{ fontSize: '14px' }} className="button-blanco-radius-detalle container-detalle-card-body-bold" onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/pp"; }}>
                  <span className="container-detalle-card-body-bold font-responsive-regresar" style={{ fontSize: '14px' }}>REGRESAR</span>
                </Button>
              )}
              {props.convocatorias?.entidad == 'MCM' && (
                <Button type="link" style={{ fontSize: '14px' }} className="button-blanco-radius-detalle container-detalle-card-body-bold" onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/mcm"; }}>
                  <span className="container-detalle-card-body-bold font-responsive-regresar" style={{ fontSize: '14px' }}>REGRESAR</span>
                </Button>
              )}
              <Button
                type="link"
                className="button-azul-radius-detalle container-detalle-card-body-bold"
                style={{ fontSize: '14px' }}
                onClick={insrcribirme}
                loading={loadingAplicar}
              >
                <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>APLICAR AHORA</span>
              </Button>
            </div>
          </div>
        )
      }
     {props.convocatorias?.entidad === 'SCC' && (
      <div>
        <ModalCondicionesGenerales
          visualizar={visualizarCondiciones}
          setVisualizar={setVisualizarCondiciones}
          nombre={props.convocatorias.linea_estrategica}
        />
        <ModalVisualizarAplicar
          visualizar={visualizarAplicar}
          setVisualizar={setVisualizarAplicar}
        />
        {/*
        {[1226, 1211, 1209, 1220, 1225].includes(props.convocatorias?.idconvocatorias) && (
          <ModalVisualizarAviso
            visualizar={visualizarAviso}
            setVisualizar={setVisualizarAviso}
          />
        )}
        */}

        {/*
        {props.convocatorias?.documentos_generales?.some(data =>
          data.descripcion.includes("Modifica")
        ) && (
          <ModalModificaciones
            visualizar={visualizarModificaciones}
            setVisualizar={setVisualizarModificaciones}
          />
        )}
        */}
      </div>
      )}
      <ModalVisualizarDocumentos
        visualizar={visualizasdocument}
        setVisualizar={setVisualizarDocument}
        state={{ documento: urldocumento }}
      />


    </div>
  );
};
